import { configureStore, combineReducers } from '@reduxjs/toolkit'


//reducer
import { ui } from 'src/reducer/uiReducer'
import { auth } from 'src/reducer/authReducer'
import { poliza } from 'src/reducer/polizaReducer'
import { pago } from 'src/reducer/pagoReducer'
import { alert } from 'src/reducer/alertReducer'
// import { reducer as toastrReducer } from 'react-redux-toastr'


const reducer = combineReducers({
    ui,
    auth,
    poliza,
    pago,
    alert
    // company,
    // exclaim,
    // comment,
    // toastr: toastrReducer // <- Mounted at toastr.
})

const store = configureStore({
    reducer,
    devTools: process.env.NODE_ENV !== 'production'
})

export default store